var _rect, _rect2, _circle, _circle2, _circle3, _rect3, _g, _g2, _rect4, _rect5, _rect6, _path, _rect7, _g3, _g4, _rect8, _rect9, _path2, _rect10, _rect11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbnailCreateWebPush(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 315,
    height: 380,
    viewBox: "0 0 315 380",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 313.5,
    height: 379,
    rx: 11.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 313.5,
    height: 379,
    rx: 11.5,
    stroke: "#F2F2F2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32,
    r: 8,
    fill: "#E4E8EC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 32,
    r: 8,
    fill: "#E4E8EC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.5,
    cy: 32,
    r: 8,
    fill: "#E4E8EC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 76,
    width: 266.5,
    height: 74,
    rx: 16,
    fill: "#F7F9FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_342_7084)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.5,
    y: 91,
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "#2D87F3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_342_7084)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.137 100.879C55.137 100.726 55.1264 100.561 55.1158 100.404C55.1052 100.107 55.0067 99.8129 54.8219 99.5297C54.3812 98.8571 53.7647 98.5315 52.9892 98.5648C52.5756 98.5891 52.2621 98.7814 52.0546 99.1374C51.8804 99.4358 51.8365 99.7932 51.9334 100.117C52.0303 100.438 52.2515 100.698 52.5529 100.846C52.7104 100.929 52.7559 101.002 52.7392 101.149V101.153V109.783C52.7392 109.805 52.7377 109.83 52.7362 109.855C52.7332 109.911 52.7317 109.97 52.7392 110.028C52.7468 110.14 52.7104 110.196 52.6029 110.242C52.1015 110.46 51.8652 110.87 51.9031 111.461C51.938 112.071 52.3954 112.514 53.0134 112.536C53.0407 112.538 53.0679 112.538 53.0952 112.538C54.2267 112.538 55.0658 111.585 55.1188 110.701C55.1309 110.54 55.14 110.384 55.14 110.222V105.557C55.14 105.039 55.1415 104.521 55.143 104.003C55.1415 102.98 55.1446 101.923 55.137 100.879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6966 110.273C49.5042 110.19 49.4436 110.083 49.4633 109.864V101.075C49.4724 100.963 49.5118 100.907 49.6087 100.869C49.6663 100.846 49.7268 100.822 49.7753 100.785C50.2146 100.496 50.416 99.9508 50.2752 99.4252C50.1222 98.8966 49.7087 98.5739 49.1664 98.5633C49.1528 98.5633 49.1391 98.5633 49.1255 98.5633C48.4818 98.5633 47.9395 98.8239 47.5139 99.3389C47.2155 99.7024 47.0625 100.148 47.0625 100.664V105.534C47.0625 106.361 47.0655 107.187 47.0686 108.009C47.0716 108.83 47.0746 109.648 47.0746 110.467C47.0746 111.176 47.4881 112.049 48.4136 112.402C48.656 112.491 48.8832 112.535 49.0998 112.535C49.2255 112.535 49.3467 112.52 49.4663 112.489C49.9253 112.374 50.2615 111.976 50.3206 111.476C50.3812 110.97 50.1252 110.476 49.6966 110.273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.4922 112.108L62.4422 111.973L62.3089 111.987C62.221 111.996 61.8272 112.011 61.447 112.024C60.5943 112.056 60.4897 112.064 60.4504 112.077L60.364 112.106L60.3655 112.199C60.3913 113.526 59.5249 114.377 58.7736 114.702C58.4646 114.836 58.1177 114.936 57.7163 115.005C56.7091 115.164 55.6927 115.164 54.6975 115.005C54.2219 114.927 53.7978 114.793 53.4373 114.61C52.9405 114.353 52.577 113.95 52.3589 113.412C52.3104 113.292 52.2665 113.164 52.224 113.039C52.1741 112.894 52.1286 112.756 52.0817 112.656C51.8772 112.18 51.3773 111.924 50.8941 112.047C50.3928 112.171 50.0596 112.608 50.0823 113.109C50.0944 113.4 50.1489 113.671 50.2716 114.048C50.3988 114.427 50.6018 114.805 50.8548 115.142C51.3137 115.764 51.9241 116.241 52.7178 116.597C53.4812 116.944 54.3234 117.149 55.2913 117.22C55.6427 117.244 55.9729 117.256 56.288 117.256C56.959 117.256 57.5573 117.202 58.1268 117.09C58.9705 116.931 59.6733 116.679 60.2762 116.323C61.4531 115.623 62.5649 114.702 62.4922 112.108Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4338 102.647C58.7437 102.647 56.5549 104.866 56.5549 107.594C56.5549 110.322 58.7437 112.541 61.4338 112.541C64.1239 112.541 66.3126 110.322 66.3126 107.594C66.3126 104.866 64.1239 102.647 61.4338 102.647ZM64.0769 107.594C64.0769 109.072 62.8909 110.276 61.4338 110.276C59.9766 110.276 58.7906 109.074 58.7906 107.594C58.7906 106.116 59.9766 104.911 61.4338 104.911C62.8909 104.911 64.0769 106.114 64.0769 107.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5264 107.795C62.6004 107.194 62.1731 106.647 61.572 106.573C60.9709 106.499 60.4236 106.926 60.3496 107.527C60.2756 108.128 60.7029 108.676 61.304 108.75C61.9051 108.824 62.4524 108.396 62.5264 107.795Z",
    fill: "white"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 88.5,
    y: 91,
    width: 127.5,
    height: 16,
    rx: 8,
    fill: "#E4E8EC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 88.5,
    y: 119,
    width: 85,
    height: 16,
    rx: 8,
    fill: "#E4E8EC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 232,
    y: 91,
    width: 44,
    height: 44,
    rx: 8,
    fill: "#E4E8EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263 106V120C263 121.1 262.1 122 261 122H247C245.9 122 245 121.1 245 120V106C245 104.9 245.9 104 247 104H261C262.1 104 263 104.9 263 106ZM253 117.51L250.9 114.98C250.69 114.73 250.31 114.74 250.12 115L247.63 118.2C247.37 118.53 247.6 119.01 248.02 119.01H260.01C260.42 119.01 260.66 118.54 260.41 118.21L256.9 113.53C256.7 113.26 256.3 113.26 256.1 113.52L253 117.51Z",
    fill: "#D2D6DC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 163,
    width: 266.5,
    height: 106,
    rx: 16,
    fill: "#F7F9FC"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_342_7084)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.5,
    y: 178,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#2D87F3"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_342_7084)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.977 183.987C48.977 183.895 48.9706 183.794 48.9642 183.699C48.9578 183.519 48.8981 183.341 48.7861 183.169C48.519 182.762 48.1453 182.564 47.6753 182.585C47.4247 182.599 47.2347 182.716 47.1089 182.932C47.0033 183.112 46.9767 183.329 47.0355 183.526C47.0942 183.72 47.2283 183.877 47.4109 183.967C47.5064 184.018 47.5339 184.062 47.5238 184.151V184.153V189.383C47.5238 189.397 47.5229 189.412 47.522 189.427C47.5202 189.461 47.5193 189.497 47.5238 189.532C47.5284 189.6 47.5064 189.634 47.4412 189.661C47.1374 189.794 46.9942 190.042 47.0171 190.4C47.0382 190.77 47.3155 191.038 47.69 191.052C47.7065 191.053 47.7231 191.053 47.7396 191.053C48.4253 191.053 48.9339 190.476 48.966 189.94C48.9734 189.842 48.9789 189.748 48.9789 189.649V186.822C48.9789 186.508 48.9798 186.194 48.9807 185.88C48.9798 185.261 48.9816 184.62 48.977 183.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6798 189.681C45.5632 189.63 45.5265 189.565 45.5384 189.433V184.106C45.5439 184.038 45.5678 184.004 45.6265 183.981C45.6614 183.967 45.6981 183.952 45.7275 183.93C45.9937 183.755 46.1158 183.425 46.0304 183.106C45.9377 182.786 45.6871 182.59 45.3585 182.584C45.3502 182.584 45.3419 182.584 45.3337 182.584C44.9435 182.584 44.6149 182.742 44.3569 183.054C44.1761 183.274 44.0834 183.544 44.0834 183.857V186.808C44.0834 187.31 44.0852 187.81 44.087 188.308C44.0889 188.806 44.0907 189.302 44.0907 189.798C44.0907 190.228 44.3413 190.757 44.9022 190.971C45.0491 191.025 45.1868 191.051 45.3181 191.051C45.3943 191.051 45.4677 191.042 45.5402 191.024C45.8184 190.954 46.0222 190.713 46.058 190.41C46.0947 190.103 45.9396 189.804 45.6798 189.681Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4347 190.792L53.4044 190.711L53.3236 190.719C53.2703 190.724 53.0317 190.734 52.8012 190.742C52.2844 190.761 52.2211 190.766 52.1972 190.774L52.1449 190.791L52.1458 190.847C52.1614 191.652 51.6363 192.168 51.181 192.365C50.9937 192.446 50.7835 192.506 50.5402 192.549C49.9297 192.645 49.3138 192.645 48.7106 192.549C48.4224 192.501 48.1654 192.42 47.9469 192.309C47.6458 192.153 47.4254 191.909 47.2933 191.583C47.2639 191.51 47.2373 191.432 47.2116 191.357C47.1813 191.269 47.1537 191.185 47.1253 191.125C47.0013 190.836 46.6984 190.681 46.4056 190.756C46.1017 190.831 45.8997 191.095 45.9135 191.399C45.9208 191.575 45.9539 191.74 46.0283 191.968C46.1054 192.198 46.2284 192.427 46.3817 192.631C46.6598 193.008 47.0298 193.298 47.5108 193.513C47.9735 193.724 48.4839 193.847 49.0705 193.891C49.2835 193.905 49.4836 193.913 49.6745 193.913C50.0812 193.913 50.4438 193.88 50.789 193.812C51.3003 193.715 51.7263 193.563 52.0916 193.347C52.8049 192.923 53.4787 192.365 53.4347 190.792Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7933 185.059C51.1629 185.059 49.8364 186.403 49.8364 188.057C49.8364 189.71 51.1629 191.055 52.7933 191.055C54.4237 191.055 55.7502 189.71 55.7502 188.057C55.7502 186.403 54.4237 185.059 52.7933 185.059ZM54.3952 188.057C54.3952 188.953 53.6764 189.683 52.7933 189.683C51.9102 189.683 51.1914 188.954 51.1914 188.057C51.1914 187.161 51.9102 186.431 52.7933 186.431C53.6764 186.431 54.3952 187.16 54.3952 188.057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4554 188.179C53.5003 187.815 53.2413 187.483 52.877 187.438C52.5127 187.393 52.181 187.652 52.1361 188.016C52.0913 188.381 52.3503 188.712 52.7146 188.757C53.0789 188.802 53.4106 188.543 53.4554 188.179Z",
    fill: "white"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 69.5,
    y: 180,
    width: 85,
    height: 16,
    rx: 8,
    fill: "#E4E8EC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 39.5,
    y: 210,
    width: 44,
    height: 44,
    rx: 8,
    fill: "#E4E8EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70 225V239C70 240.1 69.1 241 68 241H54C52.9 241 52 240.1 52 239V225C52 223.9 52.9 223 54 223H68C69.1 223 70 223.9 70 225ZM60 236.51L57.9 233.98C57.69 233.73 57.31 233.74 57.12 234L54.63 237.2C54.37 237.53 54.6 238.01 55.02 238.01H67.01C67.42 238.01 67.66 237.54 67.41 237.21L63.9 232.53C63.7 232.26 63.3 232.26 63.1 232.52L60 236.51Z",
    fill: "#D2D6DC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 99.5,
    y: 210,
    width: 176.5,
    height: 16,
    rx: 8,
    fill: "#E4E8EC"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 99.5,
    y: 238,
    width: 133,
    height: 16,
    rx: 8,
    fill: "#E4E8EC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_342_7084"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.5,
    y: 91,
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_342_7084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.25,
    height: 19.25,
    fill: "white",
    transform: "translate(47.0625 98.5625)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_342_7084"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.5,
    y: 178,
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_342_7084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.6667,
    height: 11.6667,
    fill: "white",
    transform: "translate(44.0834 182.583)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnailCreateWebPush);
export default __webpack_public_path__ + "static/media/ThumbnailCreateWebPush.4bc770b844adaa309e59c8d04003e3f9.svg";
export { ForwardRef as ReactComponent };